/* eslint-disable @typescript-eslint/no-unused-vars */
import { useContext, useEffect, useState } from 'react';
import ComponenteTables from '../../components/tables/ComponentTables/ComponentTables';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import { cadastro, table } from '../../dados/imposto/imposto.dado';
import { useApi } from '../../hooks/userApi';
import React from 'react';
import EditImposto from './EditImposto.template';
import { formataPorcentagem } from 'utils/formataPorcentagem';
import { SelectChangeEvent } from '@mui/material';

export default function Imposto() {
  const api = useApi();
  const {
    loading,
    setLoading,
    loadingMensagem,
    setLoadingMensagem,
    loadingBtn,
    setLoadingBtn,
    loadingAction,
    setLoadingAction,
  }: any = useContext(LoadingContext);

  const [imposto, setImposto] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(Number(process.env.REACT_APP_PAGINATION_DEFAULT) || 15);
  const [pageTotal, setPageTotal] = useState(0);
  const [like, setLike] = useState('all');
  const [imp, setImp] = useState();
  const [edit, setEdit] = useState<boolean>(false);
  const [allImpostos, setAllImpostos] = useState([]);
  const [selectedFilterColumns, setSelectedFilterColumns] = useState<string[]>(
    table.header.filter((column) => !['Editar', 'Excluir'].includes(column)),
  );
  //Parte do modal delete
  const [open, setOpen] = useState(false);
  const [path, setPath] = useState('');
  const [itemExclude, setItemExclude] = useState('');

  //Parte do modal delete
  const handleExcluir = (row: string) => {
    setPath('/icms-partilha/');
    setItemExclude(row);
    setOpen(true);
  };

  const getAllImpostos = async () => {
    setLoading(true);
    let allData = [];

    try {
      const initialResponse = await api.get(`/icms-partilha/paginada'?offset=0&limit=${limit}&like=${like}`);
      if (!initialResponse.status) {
        setLoadingMensagem('Desculpe ocorreu um erro!');
        setLoadingBtn('OK');
        return;
      }

      allData = [...initialResponse.results];
      const totalPages = initialResponse.page_total;

      for (let currentPage = 2; currentPage <= totalPages; currentPage++) {
        const nextPageResponse = await api.get(
          `/icms-partilha/paginada'?offset=${limit * (currentPage - 1)}&limit=${limit}&like=${like}`,
        );
        if (!nextPageResponse.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }

        allData = [...allData, ...nextPageResponse.results];
      }

      setLoading(false);
      setPageTotal(totalPages);
      setAllImpostos(allData);
    } catch (err) {
      const msg = 'Houve um erro interno, tente mais tarde. ' + err.message;
      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  useEffect(() => {
    setLoading(true);
    api
      .get(
        '/icms-partilha/paginada' +
          `?offset=${limit * (page - 1)}&limit=${limit}&like=${like}&filterColumns=${selectedFilterColumns.join(',')}`,
      )
      .then((response) => {
        if (!response.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        } else setLoading(false);
        setImposto(response.results);
        setPageTotal(response.page_total);
      })
      .catch((e) => {
        let msg = 'Houve um erro interno, tente mais tarde.' + e.message;
        if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário e/ou senha inválidos';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
    getAllImpostos();
  }, [page, like, selectedFilterColumns]);

  const handleLike = (value) => {
    setPage(1);
    setLike(value);
  };
  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleAtualizar = (row: any) => {
    setImp(row);
    setEdit(true);
  };

  function formataTable(objeto) {
    const novoObjeto = objeto.map((row) => {
      return {
        rowCell: [
          { campo: row?.nome || '-', onClick: null, link: false },
          { campo: row?.sigla || '-', onClick: null, link: false },
          { campo: formataPorcentagem(row?.consumo) || '-', onClick: null, link: false },
          { campo: formataPorcentagem(row?.revenda) || '-', onClick: null, link: false },
          { campo: formataPorcentagem(row?.contribuinte) || '-', onClick: null, link: false },
          { campo: formataPorcentagem(row?.naoContribuinte) || '-', onClick: null, link: false },
          { campo: 'Editar', onClick: () => handleAtualizar(row), link: true },
          { campo: 'Excluir', onClick: () => handleExcluir(row.id), link: true },
        ],
      };
    });
    return novoObjeto;
  }

  const arrList = {
    header: table.header,
    type: table.type,
    rows: formataTable(imposto),
  };
  const arrListAll = {
    header: table.header,
    type: table.type,
    rows: formataTable(allImpostos),
  };

  useEffect(() => {
    const savedColumns = localStorage.getItem('selectedFilterColumns');
    if (savedColumns) {
      const filteredColumns = JSON.parse(savedColumns).filter((column) => table.header.includes(column));
      setSelectedFilterColumns(filteredColumns);
    }
  }, []);

  const handleFilterColumnsChange = (event: SelectChangeEvent<string[]>) => {
    const filteredColumns = event.target.value as string[];
    const updatedFilterColumns = filteredColumns.filter(
      (column) => table.header.includes(column) && !['Editar', 'Excluir'].includes(column),
    );
    setSelectedFilterColumns(updatedFilterColumns);
    localStorage.setItem('selectedFilterColumns', JSON.stringify(updatedFilterColumns));
  };

  return (
    <>
      {!edit && (
        <ComponenteTables
          table={arrList}
          cadastro={cadastro}
          pageTotal={pageTotal}
          page={page}
          handleChangePage={handleChangePage}
          handleLike={handleLike}
          path={path} // path  do delete
          itemExclude={itemExclude} // id do item
          open={open} // abre modal delete
          setOpen={setOpen} // controle modal delete
          allData={arrListAll}
          selectedFilterColumns={selectedFilterColumns}
          handleFilterColumnsChange={handleFilterColumnsChange}
        />
      )}
      {edit && <EditImposto dado={imp} setEdit={() => setEdit(false)} />}
    </>
  );
}
